import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import vClickOutside from 'v-click-outside';

Vue.use(Vuetify);

Vue.directive('click-outside', vClickOutside.directive);
export default new Vuetify({
  theme: {
    dark: false, 
    themes: {
      dark: { primary: '#2196F3' },
      light: { primary: '#1976D2' }
    }
  }
});
